import { connect } from "react-redux";
import {
  getCampaignById,
  getSocialChannelAggregated,
  getSocialChannelStatsAggregated,
  setReportDateRange,
  setSegmentId,
  setChannelCampaignId,
  getCampaignTopLinkStats,
  clearCampaignDetail,
  getCampaignTopLocationClickStats,
} from "../../actions/Campaign";
import { selectClient } from "../../actions/App";

import SocialChannelReport from "../../components/Campaigns/Report/SocialChannelReport";

const mapStateToProps = state => {
  const { clients } = state.app;
  const {
    socialAggregatedReport,
    socialAggregatedStats,
    reportDateRange,
    campaignDetail,
    topLinkStats,
    topLocationOpensStats,
    channelCampaignId,
    segmentId,
  } = state.campaigns;
  return {
    socialAggregatedReport,
    socialAggregatedStats,
    campaignDetail,
    channelCampaignId,
    topLocationOpensStats,
    topLinkStats,
    segmentId,
    reportDateRange: reportDateRange ? reportDateRange : "life-of-campaign",
    client_id: state.app.client_info && state.app.client_info.id,
    client_tz: state.app.client_info && state.app.client_info.timezone,
    client_info: state.app.client_info,
    clients,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getCampaignById(id) {
      dispatch(getCampaignById(id, false));
    },
    selectClient(cid) {
      dispatch(selectClient(cid));
    },
    getSocialChannelAggregatedReport(
      groupCampaignId,
      deploymentId,
      dateRange,
      channelCampaignId,
    ) {
      dispatch(
        getSocialChannelAggregated(
          groupCampaignId,
          deploymentId,
          dateRange,
          channelCampaignId,
        ),
      );
    },
    getSocialChannelStatsAggregated(
      groupCampaignId,
      deploymentId,
      dateRange,
      channelCampaignId,
    ) {
      dispatch(
        getSocialChannelStatsAggregated(
          groupCampaignId,
          deploymentId,
          dateRange,
          channelCampaignId,
        ),
      );
    },
    getCampaignTopLinkStats(groupCampaignId, campaignid, dateRanges, limit) {
      dispatch(
        getCampaignTopLinkStats(
          groupCampaignId,
          campaignid,
          dateRanges,
          limit,
          "social",
        ),
      );
    },
    getCampaignTopLocationClickStats(
      groupCampaignId,
      campaignId,
      dateRange,
      limit,
    ) {
      dispatch(
        getCampaignTopLocationClickStats(
          groupCampaignId,
          campaignId,
          dateRange,
          limit,
          "social",
        ),
      );
    },
    setReportDateRange(dateRange) {
      dispatch(setReportDateRange(dateRange.value));
    },
    setChannelCampaignId(data) {
      dispatch(setChannelCampaignId(data.value));
    },
    setSegmentId(data) {
      dispatch(setSegmentId(data.value));
    },
    cleanCampaignInfo(cid) {
      dispatch(clearCampaignDetail(cid));
    },
  };
};

const SocialChannelContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SocialChannelReport);

export default SocialChannelContainer;



// WEBPACK FOOTER //
// ./src/containers/Campaigns/SocialChannelReport.js